import { iaRa } from 'lib/helpers/utility';
import { useIncomeIQueueContext } from 'lib/context/IncomeIQueueContext/IncomeIQueueContext';

import Button from 'components/shared/Button/Button';

const IncomeIQueueRunDetail = ({ activity }) => {
  const { openHistoryResult } = useIncomeIQueueContext() ?? {};
  const entries = iaRa(activity?.entries);

  return (
    <div className="pl-[9px]">
      <div className="flex flex-col gap-2 border-0 border-l border-solid border-neutral-300 pl-[13px]">
        {entries.map((entry) => (
          <p key={entry.id} className="text-sm leading-[22px] text-neutral-600">
            <span className="font-semibold text-neutral-800">
              {entry.description || entry.action_label || 'Action'}
            </span>
            <Button
              text="View"
              size="xs"
              variant="link"
              className="ml-1"
              onClick={() => openHistoryResult?.({ entries: [entry], hideNavigation: true })}
            />
          </p>
        ))}

        {entries.length > 1 && (
          <Button
            text="View execution summary"
            size="xs"
            variant="link"
            className="self-start"
            onClick={() => openHistoryResult?.({ entries })}
          />
        )}
      </div>
    </div>
  );
};

export default IncomeIQueueRunDetail;
